import { PostShareResponse } from "../../../proto/api_pb";
import { Share, ShareState, ShareType } from "../../../proto/api_pb";
import { getShareUrl } from "../../../services/shareService";

export const createAndCopyShareUrl: (
  objectId: string,
  userId: string,
  accessToken: string,
  isTrack: boolean,
  expiryTimeStamp: number,
  maxViews: number,
  allowDownload: boolean,
  isAllowUnlimitedViews: boolean,
  title: string,
  enterpriseId?: string
) => Promise<string | undefined> = async (
  objectId: string,
  userId: string,
  accessToken: string,
  isTrack: boolean,
  expiryTimeStamp: number,
  maxViews: number,
  allowDownload: boolean,
  isAllowUnlimitedViews: boolean,
  title: string,
  enterpriseId?: string
) => {
    const share = new Share();
    share.setObjectId(objectId);
    share.setOwnerId(userId);
    share.setExpiryTimestamp(expiryTimeStamp);
    share.setMaxViews(maxViews);
    share.setAllowDownload(allowDownload);
    share.setUnlimitedViews(isAllowUnlimitedViews);
    share.setTrackTitle(title);
    if (isTrack) {
      share.setShareType(ShareType.SHARE_TYPE_TRACK);
    } else {
      share.setShareType(ShareType.SHARE_TYPE_TRACK_FILE);
    }
    share.setShareState(ShareState.SHARE_STATE_ACTIVE);

    const response = await getShareUrl(accessToken, userId, share, enterpriseId);
    if (response instanceof PostShareResponse) {
      const id = response.getShare()?.getId();
      const shareLink = `${process.env.REACT_APP_URL}/share/${id}`;
      navigator.clipboard
        .writeText(shareLink)
        .then(() => {
          console.log("Url successfully copied to clipboard");
        })
        .catch((err) => {
          console.error("Unable to copy Url to clipboard", err);
        });
      return shareLink;
    }
  };

export const createAndCopyFolderShareUrl: (
  objectId: string,
  userId: string,
  accessToken: string,
  expiryTimeStamp: number,
  maxViews: number,
  allowDownload: boolean,
  isAllowUnlimitedViews: boolean,
  title: string,
  enterpriseId?: string
) => Promise<string | undefined> = async (
  objectId: string,
  userId: string,
  accessToken: string,
  expiryTimeStamp: number,
  maxViews: number,
  allowDownload: boolean,
  isAllowUnlimitedViews: boolean,
  title: string,
  enterpriseId?: string
) => {
    const share = new Share();
    share.setShareType(ShareType.SHARE_TYPE_FOLDER);
    share.setShareState(ShareState.SHARE_STATE_ACTIVE);
    share.setObjectId(objectId);
    share.setOwnerId(userId);
    share.setExpiryTimestamp(expiryTimeStamp);
    share.setMaxViews(maxViews);
    share.setAllowDownload(allowDownload);
    share.setUnlimitedViews(isAllowUnlimitedViews);
    share.setTrackTitle(title);

    const response = await getShareUrl(accessToken, userId, share, enterpriseId);
    if (response instanceof PostShareResponse) {
      const id = response.getShare()?.getId();
      const shareLink = `${process.env.REACT_APP_URL}/share/${title}/${id}`;
      navigator.clipboard
        .writeText(shareLink)
        .then(() => {
          console.log("Url successfully copied to clipboard");
        })
        .catch((err) => {
          console.error("Unable to copy Url to clipboard", err);
        });
      return shareLink;
    }
  };

export const createAndCopyProjectShareUrl: (
  objectId: string,
  userId: string,
  accessToken: string,
  expiryTimeStamp: number,
  maxViews: number,
  allowDownload: boolean,
  isAllowUnlimitedViews: boolean,
  title: string,
  enterpriseId?: string
) => Promise<string | undefined> = async (
  objectId: string,
  userId: string,
  accessToken: string,
  expiryTimeStamp: number,
  maxViews: number,
  allowDownload: boolean,
  isAllowUnlimitedViews: boolean,
  title: string,
  enterpriseId?: string
) => {
    const share = new Share();
    share.setShareType(ShareType.SHARE_TYPE_PROJECT);
    share.setShareState(ShareState.SHARE_STATE_ACTIVE);
    share.setObjectId(objectId);
    share.setOwnerId(userId);
    share.setExpiryTimestamp(expiryTimeStamp);
    share.setMaxViews(maxViews);
    share.setAllowDownload(allowDownload);
    share.setUnlimitedViews(isAllowUnlimitedViews);
    share.setTrackTitle(title);

    const response = await getShareUrl(accessToken, userId, share, enterpriseId);
    if (response instanceof PostShareResponse) {
      const id = response.getShare()?.getId();
      const shareLink = `${process.env.REACT_APP_URL}/share/project/${title}/${id}`;
      navigator.clipboard
        .writeText(shareLink)
        .then(() => {
          console.log("Url successfully copied to clipboard");
        })
        .catch((err) => {
          console.error("Unable to copy Url to clipboard", err);
        });
      return shareLink;
    }
  };